import { createBrowserHistory, createMemoryHistory } from 'history';
import type { History } from 'history';
import type { Nullable } from '../types';

const initialValue = null;
let history: Nullable<History> = initialValue;

const getMemoryHistoryOptions = (basename: string, pathname: string) => {
  if (!basename) {
    return {
      initialEntries: ['/'],
      initialIndex: 0,
    };
  }

  if (!pathname) {
    return {
      initialEntries: [basename],
      initialIndex: 0,
    };
  }

  return {
    initialEntries: [basename, pathname],
    initialIndex: 1,
  };
};

export const getHistory = () => history;

interface Options {
  basename: string;
  [x: string]: any;
}
/**
 * Returns instance of browser or hash history (dynamically checks type of hash-based routing)
 * @param {boolean} useMemoryHistory
 * @param {string} basename - the base URL of the app
 * @param {string} pathname - the initial pathname  of the app
 * @param rest
 * @returns {{createHref: (function(*=): string), goBack: (function(): void), length: number, replace: replace, go: go, action: string, location, goForward: (function(): void), block: (function(): function(): void), push: push, listen}, null}
 */
export const createHistory = (
  useMemoryHistory = false,
  { basename = '', pathname, ...rest }: Options
) => {
  if (useMemoryHistory) {
    history = createMemoryHistory({
      ...getMemoryHistoryOptions(basename, pathname),
      ...rest,
    });
  } else {
    history = createBrowserHistory({ basename, ...rest });
  }

  return getHistory();
};

export const resetHistory = () => {
  history = initialValue;
};
